module.exports = __webpack_public_path__ + "static/img/icon_logo.b8bbf6fa.png";